<!--
 * @Description:
 * @Author: jiangling
 * @Date: 2021-04-06
 -->
<template>
  <h1>404</h1>
</template>

<script>
export default {
  name: "404"
}
</script>

<style scoped>

</style>
